<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div class="col-md-12 manual_record">
          <div class="header row">
            <div class="left">
              <img src="@/assets/img/Group_10680.svg" />
            </div>

            <div class="left">
              <h4>
                {{ $t("text.bManualRec.updatedReject") }}
                {{ rejectedRecord.name }}
              </h4>
              <p></p>
            </div>
          </div>
          <br class="clear" />
          <div class="body row">
            <div class="col-md-12" style="padding: 0 !important">
              <div class="stepper-body row justify-content-around">
                <!-- PUMPS -->
                <div class="col-md-6" v-if="rejectedRecord.dataType === 'Pump'">
                  <div class="row inner-meter">
                    <div class="col-md-6">
                      <label>{{ $t("text.bManualRec.oirm") }}</label>
                      <input
                        type="number"
                        placeholder="0"
                        v-model="rejectedRecord.innerOpeningReading"
                      />
                    </div>
                    <div class="col-md-6">
                      <label>{{ $t("text.bManualRec.orom") }}</label>
                      <input
                        type="number"
                        placeholder="0"
                        v-model="rejectedRecord.outerOpeningReading"
                      />
                    </div>
                  </div>

                  <div class="row outer-meter">
                    <div class="col-md-6">
                      <label>{{ $t("text.bManualRec.cirm") }}</label>
                      <input
                        type="number"
                        placeholder="0"
                        v-model="rejectedRecord.innerClosingReading"
                      />
                    </div>
                    <div class="col-md-6">
                      <label>{{ $t("text.bManualRec.crom") }}</label>
                      <input
                        type="number"
                        placeholder="0"
                        v-model="rejectedRecord.outerClosingReading"
                      />
                    </div>
                  </div>

                  <div>
                    <label>{{ $t("text.bManualRec.rtt") }}</label>
                    <input
                      type="number"
                      placeholder="0"
                      v-model="rejectedRecord.rtt"
                    />
                  </div>

                  <div>
                    <label>{{ $t("text.bManualRec.trf") }}</label>
                    <input
                      type="number"
                      placeholder="0"
                      v-model="rejectedRecord.transfer"
                    />
                  </div>
                </div>
                <!-- PUMPS End -->

                <!-- TANKS -->
                <div
                  class="col-md-6"
                  v-else-if="rejectedRecord.dataType === 'Tank'"
                >
                  <div>
                    <label>{{ $t("text.bManualRec.openingDip") }}</label>
                    <input
                      type="number"
                      placeholder="0"
                      v-model="rejectedRecord.openingDip"
                    />
                  </div>

                  <div>
                    <label>{{ $t("text.bManualRec.closingDip") }}</label>
                    <input
                      type="number"
                      placeholder="0"
                      v-model="rejectedRecord.closingDip"
                    />
                  </div>

                  <!-- <div>
                     <label>Dip Time</label>
                    <input type="time" placeholder="0" v-model="rejectedRecord.date"/>
                   </div> -->

                  <div>
                    <label>{{ $t("text.bManualRec.volDisc") }}</label>
                    <input
                      type="number"
                      placeholder="0"
                      v-model="rejectedRecord.filledVolume"
                    />
                  </div>
                </div>
                <!-- TANKS End -->
              </div>
              <div
                class="stepper-buttons row justify-content-center"
                v-if="rejectedRecord"
              >
                <div class="col-md-2">
                  <button
                    class="next"
                    :disabled="disabled"
                    @click="updateRecord"
                  >
                    {{ $t("text.bManualRec.updateRecord") }}
                    <img
                      src="@/assets/img/git_loader.gif"
                      v-show="submitting"
                      width="25px"
                      class="ml-3 loader"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import configObject from "@/config";

export default {
  name: "updateRejectedRecord",
  components: {
    MasterLayout,
  },
  created() {
    document.title = "Update Rejected Record:: Epump Retail Outlet";
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Update Rejected Record:: ${branch.name} Retail Outlet`;
    });
  },
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.$route.query.branchId;
        if (this.branchId !== null) {
          this.rejectedRecord = JSON.parse(this.$route.query.data);
        }
      }
    },
  },
  data() {
    return {
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      branch: {},
      submitting: false,
      disabled: false,
      branchId: null,
      rejectedRecord: {},
    };
  },
  methods: {
    updateRecord() {
      this.submitting = true;
      this.disabled = true;
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Branch/UpdateRejectedData/${this.branchId}`,
          this.rejectedRecord,
          configObject.authConfig()
        )
        .then((response) => {
          this.submitting = false;
          if (response.status <= 200) {
            this.$toast.open({
              message: this.$t("text.bManualRec.recordUpdated"),
              type: "success",
              duration: 5000,
            });
            window.history.back();
          } else {
            this.disabled = false;
            this.$toast.open({
              message: response.statusText,
              type: "error",
              duration: 5000,
            });
          }
        })
        .catch((error) => {
          this.submitting = false;
          this.disabled = false;
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },
  },
};
</script>
